import { Logtail } from "@logtail/browser";

const sourceToken = import.meta.env.VITE_BETTERSTACK_SOCKET_SOURCE_TOKEN;
const enabled = import.meta.env.VITE_BETTERSTACK_SOCKET_ENABLED === 'true';
// Хост без протоколу (напр. "s123.eu-fsn-3.betterstackdata.com") браузер трактує як відносний шлях - логи йшли на
// localhost/<сторінка>/... і отримували 404. Без протоколу - https:// (2026-09-30).
const rawIngestingHost: string | undefined = import.meta.env.VITE_BETTERSTACK_SOCKET_INGESTING_HOST;
const ingestingHost = rawIngestingHost && !/^https?:\/\//.test(rawIngestingHost) ? `https://${rawIngestingHost}` : rawIngestingHost;
const logLevel = (import.meta.env.VITE_BETTERSTACK_SOCKET_LOG_LEVEL || 'debug') as 'debug' | 'info' | 'warn' | 'error';

let socketLogtail: Logtail | null = null;

const LOG_LEVELS = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const shouldLog = (level: keyof typeof LOG_LEVELS) => {
  return LOG_LEVELS[level] >= LOG_LEVELS[logLevel];
};

export const initSocketLogger = () => {
  if (enabled && sourceToken) {
    try {
      socketLogtail = new Logtail(sourceToken, {
        endpoint: ingestingHost,
      });
    } catch (error) {
      console.error("[SocketLogger] Failed to initialize Better Stack socket logger", error);
    }
  }
};

export const logSocketEvent = (type: 'emit' | 'on' | 'connect' | 'disconnect' | 'error', eventName: string, data?: any) => {
  if (!socketLogtail) return;

  const message = `[Socket] ${type.toUpperCase()} ${eventName}`;
  const context = {
    event: eventName,
    type,
    data: data ? JSON.stringify(data) : undefined,
    timestamp: new Date().toISOString()
  };

  if (type === 'error') {
    if (shouldLog('error')) {
      socketLogtail.error(message, context);
    }
  } else if (type === 'disconnect') {
    if (shouldLog('warn')) {
      socketLogtail.warn(message, context);
    }
  } else {
    if (shouldLog('debug')) {
      socketLogtail.info(message, context);
    }
  }
};

export default socketLogtail;
